import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'

export const createWebsiteLogo = (
  parentId: string,
  masterBlockId?: MasterBlockId,
): WebsiteLogoInterface => {
  const entity: WebsiteLogoInterface = {
    ...generateBaseEntity(EntityTypeEnum.WebsiteLogo, parentId, masterBlockId),
    type: EntityTypeEnum.WebsiteLogo,
    logoFileId: null,
    mobileLogoFileId: null,
    logoText: 'Logo',
  }
  return entity
}
